<template>
    <section class="dp-layout">
        <section class="dp-left">
            <DepartmentPane directory-scope="school" @tree-node-click="treeNodeClick" :type="1"></DepartmentPane>
        </section>

        <section class="dp-right">
            <!--工具条-->
            <toolbar :buttonList="buttonList" @callFunction="callFunction" :searchList="searchList"></toolbar>

            <!--列表-->
            <div class="tbl-scroll-host">
            <el-table :data="users" v-loading="listLoading" ref="table" class="custom-tbl" height="100%" style="width: 100%">
                <el-table-column prop="PushType" label="推送类型" width="130">
                    <template slot-scope="scope">
                        {{ formatPushType(scope.row) }}
                    </template>
                </el-table-column>
                <el-table-column prop="PushChannel" label="通道" width="90">
                    <template slot-scope="scope">
                        {{ formatPushChannel(scope.row.PushChannel) }}
                    </template>
                </el-table-column>
                <el-table-column prop="Content" label="推送内容" min-width="220" show-overflow-tooltip></el-table-column>
                <el-table-column prop="DepartmentName" label="部门" width="220" show-overflow-tooltip></el-table-column>
                <el-table-column prop="UserName" label="接收对象" width="120" show-overflow-tooltip>
                    <template slot-scope="scope">
                        {{ formatRecipient(scope.row) }}
                    </template>
                </el-table-column>
                <el-table-column prop="DeliveryStatus" label="投递状态" width="90">
                    <template slot-scope="scope">
                        <el-tag :type="deliveryStatusTagType(scope.row)">
                            {{ formatDeliveryStatus(scope.row) }}
                        </el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="PushTime" label="推送时间" width="160">
                    <template slot-scope="scope">
                        {{ formatDateTime(scope.row.PushTime) }}
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="80" fixed="right" align="center">
                    <template slot-scope="scope">
                        <el-button type="text" size="small" @click="openDetail(scope.row)">详情</el-button>
                    </template>
                </el-table-column>
            </el-table>
            </div>
            <!--工具条-->
            <el-col :span="24" class="toolbar">
                <el-pagination layout="total, prev, pager, next, jumper" @current-change="handleCurrentChange" :page-size="10"
                    :total="total" style="float: right">
                </el-pagination>
            </el-col>

            <el-dialog title="推送日志详情" custom-class="push-log-detail-dialog" :visible.sync="logDetailVisible" width="720px" :close-on-click-modal="false">
                <div v-if="logDetail" class="push-log-detail">
                    <div class="push-log-detail__section">
                        <div class="push-log-detail__title">基础信息</div>
                        <div class="push-log-detail__grid">
                            <span>记录 ID：{{ logDetail.Id || '—' }}</span>
                            <span>推送类型：{{ formatPushType(logDetail) }}</span>
                            <span>通道：{{ formatPushChannel(logDetail.PushChannel) }}</span>
                            <span>投递状态：{{ formatDeliveryStatus(logDetail) }}</span>
                            <span>部门：{{ logDetail.DepartmentName || '—' }}</span>
                            <span>接收对象：{{ formatRecipient(logDetail) }}</span>
                            <span>推送时间：{{ formatDateTime(logDetail.PushTime) }}</span>
                            <span>返回码：{{ logDetail.Errcode == null ? '—' : logDetail.Errcode }}</span>
                            <span v-if="logDetail.CardNumber">卡号：{{ logDetail.CardNumber }}</span>
                        </div>
                    </div>
                    <div v-if="isDismissalLog(logDetail)" class="push-log-detail__section">
                        <div class="push-log-detail__title">放学事件信息</div>
                        <div class="push-log-detail__grid">
                            <span>放学事件 ID：{{ logDetail.EventId || '—' }}</span>
                            <span>推送批次：{{ logDetail.BatchIndex ? `${logDetail.BatchIndex}/${logDetail.BatchTotal}` : '—' }}</span>
                            <span>接收人数：{{ logDetail.RecipientCount == null ? '—' : logDetail.RecipientCount }}</span>
                            <span>卡号：{{ logDetail.CardNumber || '—' }}</span>
                        </div>
                    </div>
                    <div v-if="isDingTalkLog(logDetail)" class="push-log-detail__section">
                        <div class="push-log-detail__title">钉钉推送结果</div>
                        <div class="push-log-detail__grid">
                            <span>钉钉任务编号：{{ logDetail.DingTaskId || '—' }}</span>
                            <span>实际接收人数：{{ logDetail.RecipientCount == null ? '—' : logDetail.RecipientCount }}</span>
                            <span>已读/未读：{{ formatReadStatus(logDetail) }}</span>
                            <span>返回码：{{ logDetail.Errcode == null ? '—' : logDetail.Errcode }}</span>
                        </div>
                    </div>
                    <div v-else-if="isQueueLog(logDetail)" class="push-log-detail__section">
                        <div class="push-log-detail__title">通道处理信息</div>
                        <div class="push-log-detail__grid">
                            <span>处理对象：{{ formatRecipient(logDetail) }}</span>
                            <span>处理结果：{{ formatDeliveryStatus(logDetail) }}</span>
                            <span>说明：该记录为通道总控记录，不代表具体接收人</span>
                        </div>
                    </div>
                    <div class="push-log-detail__section">
                        <div class="push-log-detail__title">推送内容</div>
                        <div class="push-log-detail__text">{{ logDetail.Content || '—' }}</div>
                    </div>
                    <div class="push-log-detail__section">
                        <div class="push-log-detail__title">结果与诊断</div>
                        <div class="push-log-detail__text">{{ logDetail.Errmsg || '—' }}</div>
                        <div v-if="logDetail.InvalidUserIds" class="push-log-detail__invalid">
                            未送达钉钉账号：{{ logDetail.InvalidUserIds }}
                        </div>
                    </div>
                </div>
            </el-dialog>
        </section>
    </section>
</template>

<script>
import util from "../../../util/date";
import { getPushNotificationListPage, getPushNotificationDetail } from '../../api/modules/misc';
import { BaseApiUrl } from '../../api/base';
import { getButtonList } from "../../promissionRouter";
import Toolbar from "../../components/Toolbar";
import DepartmentPane from '../../components/DepartmentPane'

const PUSH_TYPE_NAMES = {
    DismissalParentNotify: '家长放学通知',
    DismissalHeadTeacherNotify: '班主任放学通知',
    DismissalDetainParentNotify: '家长滞留通知',
    FlowingRedFlagReview: '流动红旗审核',
    ClassCheckScoreChange: '班级考核分数变更',
    StudentCheckScoreChange: '学生考核分数变更',
    MissingAttendance: '缺勤提醒',
    MissingAttendanceSpecial: '特殊缺勤提醒',
    DeYuStudentEval: '德育学生评价',
    TeacherKaoQin: '教师考勤',
    ClassCircleNewPost: '班级圈新动态',
    AgreementCoinGrant: '协议积分发放',
    HonorCollectionPendingClassTeacher: '荣誉采集待班主任处理',
    HonorCollectionPendingSchool: '荣誉采集待学校处理',
    MeetingRoomBooking: '会议室预约',
    MeetingRoomBookingReminder: '会议室预约提醒',
    FiveEducationSubjectRemind: '五育提醒'
};
const QUEUE_SUFFIX = '推送总控';
const QUEUE_TYPE_NAMES = {
    DismissalParentNotify: '放学'
};

export default {
    components: { Toolbar, DepartmentPane },
    data() {
        return {
            filters: {},
            BaseApiUrl: BaseApiUrl,
            searchList: [
                {
                    label: '推送时间',
                    key: 'dateRange',
                    type: 'daterange',
                    format: 'yyyy-MM-dd',
                    width: '260px'
                },
                { label: '推送类型', key: 'pushType' },
                {
                    label: '通道', key: 'pushChannel', type: 'select', clearable: true, options: [
                        { label: '全部', value: '' },
                        { label: '队列/总控', value: 'Queue' },
                        { label: '微信', value: 'WeChat' },
                        { label: '钉钉', value: 'DingTalk' }
                    ]
                },
                {
                    label: '投递状态', key: 'deliveryStatus', type: 'select', clearable: true, options: [
                        { label: '全部', value: '' },
                        { label: '待处理', value: 'PENDING' },
                        { label: '成功', value: 'SUCCESS' },
                        { label: '失败', value: 'FAILED' }
                    ]
                },
                { label: '接收人', key: 'userName' },
                { label: '卡号', key: 'cardNumber' },
                { label: '放学事件编号', key: 'eventId' },
                { label: '内容', key: 'content' }
            ],
            users: [],
            total: 0,
            buttonList: [],
            page: 1,
            listLoading: false,
            DepartmentId: 0,
            logDetailVisible: false,
            logDetail: null,
        };
    },
    methods: {
        treeNodeClick(data) {
            this.DepartmentId = data.value
            this.page = 1;
            this.handleQuery();
        },
        callFunction(item) {
            if (typeof item.search == 'object') {
                this.filters = item.search
            } else {
                this.filters = {
                    key: item.search,
                }
            }
            this[item.Func].apply(this, item)
        },
        handleCurrentChange(val) {
            this.page = val;
            this.handleQuery();
        },
        /**
         * 当天日期 yyyy-MM-dd。创建于 2026-09-16
         * @returns {string}
         */
        getTodayDateStr() {
            const now = new Date();
            const year = now.getFullYear();
            const month = String(now.getMonth() + 1).padStart(2, '0');
            const day = String(now.getDate()).padStart(2, '0');
            return `${year}-${month}-${day}`;
        },
        /**
         * 组装查询参数：dateRange 拆成 startTime/endTime，未选时默认当天。创建于 2026-09-16
         * @returns {Object}
         */
        buildQueryParams() {
            const filters = { ...(this.filters || {}) };
            let startTime = '';
            let endTime = '';
            if (filters.dateRange && Array.isArray(filters.dateRange) && filters.dateRange.length === 2) {
                startTime = filters.dateRange[0] || '';
                endTime = filters.dateRange[1] || '';
            }
            delete filters.dateRange;
            if (!startTime || !endTime) {
                const today = this.getTodayDateStr();
                startTime = today;
                endTime = today;
            }
            let typeKeyword = String(filters.pushType || '').trim();
            if (typeKeyword.includes('总控')) {
                if (!filters.pushChannel) filters.pushChannel = 'Queue';
                typeKeyword = typeKeyword.replace(QUEUE_SUFFIX, '').replace('总控', '').trim();
            }
            filters.pushType = typeKeyword;
            if (typeKeyword) {
                filters.pushTypes = Object.keys(PUSH_TYPE_NAMES)
                    .filter(type => PUSH_TYPE_NAMES[type].includes(typeKeyword) || (QUEUE_TYPE_NAMES[type] || '').includes(typeKeyword))
                    .join(',');
            }
            return {
                page: this.page,
                departmentId: this.DepartmentId,
                ...filters,
                startTime,
                endTime
            };
        },
        // 获取推送记录列表
        handleQuery() {
            const para = this.buildQueryParams();
            this.listLoading = true;
            getPushNotificationListPage(para).then((res) => {
                this.total = res.data.response.dataCount
                this.users = res.data.response.data
                this.listLoading = false
            });
        },
        formatDateTime(val) {
            if (!val) return '';
            const d = new Date(val);
            return d.toLocaleString();
        },
        /**
         * 通道中文展示
         * @param {string} channel
         * @returns {string}
         */
        formatPushChannel(channel) {
            if (channel === 'WeChat') return '微信';
            if (channel === 'DingTalk') return '钉钉';
            if (channel === 'Queue') return '队列/总控';
            return channel || '—';
        },
        formatPushType(row) {
            const type = row && row.PushType;
            if (this.isQueueLog(row)) {
                const baseName = QUEUE_TYPE_NAMES[type] || PUSH_TYPE_NAMES[type] || this.friendlyPushTypeName(type);
                return baseName === '—' ? '推送总控' : `${baseName}${QUEUE_SUFFIX}`;
            }
            return PUSH_TYPE_NAMES[type] || this.friendlyPushTypeName(type);
        },
        friendlyPushTypeName(type) {
            if (!type) return '—';
            return /[\u4e00-\u9fa5]/.test(type) ? type : '其他推送';
        },
        formatRecipient(row) {
            if (!row) return '—';
            if (this.isQueueLog(row)) return row.UserName ? `${row.UserName}（通道总控）` : '家长（通道总控）';
            return row.UserName || '—';
        },
        /**
         * 判断是否为放学事件推送记录。
         * @param {Object} row
         * @returns {boolean}
         */
        isDismissalLog(row) {
            return !!(row && (row.EventId || String(row.PushType || '').indexOf('放学') >= 0));
        },
        /**
         * 判断是否为钉钉推送记录。
         * @param {Object} row
         * @returns {boolean}
         */
        isDingTalkLog(row) {
            return !!(row && String(row.PushChannel || '').toLowerCase() === 'dingtalk');
        },
        isQueueLog(row) {
            return !!(row && String(row.PushChannel || '').toLowerCase() === 'queue');
        },
        formatReadStatus(row) {
            if (!this.isDingTalkLog(row) || !row.DingTaskId || !row.RecipientCount) return '—';
            return `${row.ReadCount || 0}/${row.UnreadCount || 0}`;
        },
        /**
         * 解析投递状态：无 DeliveryStatus 时回退 IsSuccess
         * @param {Object} row
         * @returns {string}
         */
        resolveDeliveryStatus(row) {
            if (!row) return 'FAILED';
            if (row.DeliveryStatus) return String(row.DeliveryStatus).toUpperCase();
            return row.IsSuccess ? 'SUCCESS' : 'FAILED';
        },
        /**
         * 投递状态中文
         * @param {Object} row
         * @returns {string}
         */
        formatDeliveryStatus(row) {
            const status = this.resolveDeliveryStatus(row);
            if (status === 'PENDING') return '待处理';
            if (status === 'SUCCESS') return '成功';
            if (status === 'FAILED') return '失败';
            return status || '—';
        },
        /**
         * 投递状态标签颜色
         * @param {Object} row
         * @returns {string}
         */
        deliveryStatusTagType(row) {
            const status = this.resolveDeliveryStatus(row);
            if (status === 'PENDING') return 'warning';
            if (status === 'SUCCESS') return 'success';
            return 'danger';
        },
        async openDetail(row) {
            this.logDetail = row;
            this.logDetailVisible = true;
            try {
                const res = await getPushNotificationDetail({ id: row.Id });
                if (res.data && res.data.success && res.data.response) {
                    this.logDetail = res.data.response;
                }
            } catch (e) {
                // 原列表记录仍可正常展示，详情刷新失败不阻断查看。
            }
        }
    },
    mounted() {
        let routers = window.localStorage.router
            ? JSON.parse(window.localStorage.router)
            : [];
        this.buttonList = getButtonList(this.$route.path, routers);
    },
};
</script>

<style scoped>
.custom-tbl /deep/ th {
    background: #f7f9fc;
    color: #52657d;
    font-weight: 600;
}

.custom-tbl /deep/ td {
    color: #5d6f85;
}

.custom-tbl /deep/ .has-gutter .el-checkbox {
    display: none;
}

.push-log-detail__section {
    padding: 14px 0;
    border-bottom: 1px solid #edf0f5;
}

.push-log-detail__section:last-child {
    border-bottom: 0;
}

.push-log-detail__title {
    margin-bottom: 10px;
    color: #30445f;
    font-weight: 600;
}

.push-log-detail__grid {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 10px 24px;
    color: #66758a;
    font-size: 13px;
}

.push-log-detail__text {
    padding: 10px 12px;
    color: #53647a;
    background: #f7f9fc;
    border-radius: 4px;
    line-height: 1.6;
    white-space: pre-wrap;
    word-break: break-all;
}

.push-log-detail__invalid {
    margin-top: 8px;
    color: #c45656;
    font-size: 13px;
    word-break: break-all;
}

.push-log-detail-dialog /deep/ .el-dialog__body {
    max-height: 72vh;
    overflow-y: auto;
    padding: 8px 20px 20px;
}

@media screen and (max-width: 900px) {
    .push-log-detail__grid {
        grid-template-columns: 1fr;
    }
}

</style>
